/** Eunerd logo as inline SVG. Suporta mono-cor via prop `mono`. */
import type { SVGProps } from "react";

interface EunerdMarkProps extends SVGProps<SVGSVGElement> {
  /** Force toda a marca pra essa cor (ignora azul/cinza original) */
  mono?: string;
}

export function EunerdMark({ mono, ...props }: EunerdMarkProps) {
  const blueColor = mono ?? "#53b7e8";
  const grayColor = mono ?? "#77787b";
  return (
    <svg
      role="img"
      aria-label="Eunerd"
      viewBox="0 0 1021 960"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fill={grayColor}
        d="m122.5 704.5v-118.3h86.7v26.6h-56.2v18.4h55v26.6h-55v20h56.2v26.7z"
      />
      <path
        fill={grayColor}
        d="m227 656.6v-70.4h31v69.3c0 14 8.3 24.1 25 24.1 16.3 0 24.8-10.1 24.8-24.1v-69.3h30.9v70.2c0 29.4-17.9 50.2-55.7 50.2-38.1 0-56-20.9-56-50z"
      />
      <path
        fill={blueColor}
        d="m440.5 704.5l-50-68.5v68.5h-30.6v-118.3h31.4l47.9 65v-65h30.7v118.3z"
      />
      <path
        fill={blueColor}
        d="m491.2 704.5v-118.3h86.7v26.6h-56.2v18.4h54.9v26.6h-54.9v20h56.2v26.7z"
      />
      <path
        fillRule="evenodd"
        fill={blueColor}
        d="m661.6 704.5l-19.9-39.8h-15.6v39.8h-30.5v-118.3h59.2c26.3 0 41.2 17.4 41.2 39.3 0 20.6-12.6 31.6-23.6 35.5l24.1 43.5zm3.4-79.1c0-8-6.7-12.6-14.7-12.6h-24.2v25.3h24.2c8 0 14.7-4.4 14.7-12.7z"
      />
      <path
        fillRule="evenodd"
        fill={blueColor}
        d="m712.8 704.5v-118.3h49.7c37.2 0 64 22.3 64 59 0 36.7-26.8 59.3-63.9 59.3zm82.5-59.3c0-18.2-11-32.4-32.6-32.4h-19.4v65h19.2c20.7 0 32.8-15 32.8-32.6z"
      />
      <path
        fill={grayColor}
        d="m290.6 361.2c-5.5 0-10.1 3.4-14 10.1-3.8 6.7-5.8 14.8-5.8 24.5 0 9.9 2 18.3 5.8 25 3.9 6.7 8.5 10.1 14 10.1 5.1 0 9.7-3.4 13.6-10.1 3.8-6.7 5.7-15.1 5.7-25 0-9.7-1.9-17.8-5.7-24.5-3.9-6.7-8.5-10.1-13.6-10.1z"
      />
      <path
        fill={grayColor}
        d="m665.3 361.2c-5.5 0-10.1 3.4-14 10.1-3.9 6.7-5.8 14.8-5.8 24.5 0 9.9 1.9 18.3 5.8 25 3.9 6.7 8.5 10.1 14 10.1 5.1 0 9.7-3.4 13.5-10.1 3.9-6.7 5.8-15.1 5.8-25 0-9.7-1.9-17.8-5.8-24.5-3.8-6.7-8.4-10.1-13.5-10.1z"
      />
      <path
        fill={blueColor}
        d="m862.4 274.4h-36.4v-34.4c0.1-0.6 0.2-1.2 0.2-1.9 0-8.8-7.2-16-16-16-8.9 0-16.1 7.2-16.1 16v36.5h-34.4c-0.6-0.1-1.2-0.2-1.8-0.2-8.9 0-16.1 7.2-16.1 16 0 8.9 7.2 16.1 16.1 16.1h36.4v34.4c-0.1 0.6-0.2 1.2-0.2 1.8 0 8.9 7.2 16.1 16.1 16.1 8.8 0 16-7.2 16-16.1v-36.4h34.4c0.6 0.1 1.2 0.2 1.8 0.2 8.9 0 16.1-7.2 16.1-16.1 0-8.8-7.2-16-16.1-16z"
      />
      <path
        fillRule="evenodd"
        fill={grayColor}
        d="m826.2 396.3v49c0 12.3-1.8 27.8-8.7 42.3-11.5 24.5-37.2 46.3-92.3 46.3h-96.6c-86.8 0-100.4-54.7-100.6-87.8v-52.6c-16.5-7.7-34.9-12.1-54.3-12.1-19.4 0-37.7 4.3-54.1 12v51.9c0 33.1-13.2 88.6-101.1 88.6h-96.6c-41.3 0-65.6-12.6-80.2-29.1l-1.1-1-6.2-9.1c-10-16.5-13-35-13-49.4v-82.2l0.2-3.2c0.1-6.1 0.8-12.8 2.3-19.8l1.3-5.9c2.3-8.4 6.2-16.8 11.7-24.6l2.3-3.6c5.2-6.5 12.5-12 20.9-16.9 14.7-8.7 34.2-14.5 61.8-14.5h96.6c23.4 0 41.3 4.1 55.3 10.5 38.4 17.6 45.8 53.8 45.8 78v7.4c16.9-6 35.1-9.3 54.1-9.3 19 0 37.3 3.4 54.3 9.4v-11.6c0.8-23.7 9.3-56.3 44.2-73.1 14.1-6.9 32.2-11.3 56.3-11.3h74.1c0.6-0.1 1.2-0.2 1.8-0.2 8.9 0 16 7.2 16 16 0 8.9-7.1 16.1-16 16.1h-75.9c-60.7 0-68.4 30.3-68.4 56.6v82.2c0 26.3 7.7 56.6 68.4 56.6h96.6c61.1 0 68.9-30.3 68.9-56.6v-49c0-8.9 7.2-16.1 16.1-16.1 8.8 0 16 7.2 16 16.1zm-438.6-33.2c0-26.3-7.9-56.6-69-56.6h-96.6c-60.7 0-68.4 30.3-68.4 56.6v82.2c0 26.3 7.7 56.6 68.4 56.6h96.6c61.1 0 69-30.3 69-56.6z"
      />
    </svg>
  );
}
